module.exports = __webpack_public_path__ + "../../../static/img/c_im_15.1c70e700.png";